import React from "react";
import Chart from "chart.js";

export default function GpaChart(props) {
  React.useEffect(() => {
    let config = {
      type: "bar",
      data: {
        labels:  props.data.xaxis,
        datasets: [
          {
            label: "Level 1",
            backgroundColor: "#285A84",
            borderColor: "#ed64a6",
            data: props.data.yaxis.level1,
            fill: false,
            barThickness: 10,
          },
          {
            label: "Level 2",
            fill: false,
            backgroundColor: "#6d4c41",
            borderColor: "#4c51bf",
            data: props.data.yaxis.level2,
            barThickness: 10,
          },
          {
            label: "Level 3",
            backgroundColor: "#004d4",
            borderColor: "#ed64a6",
            data: props.data.yaxis.level3,
            fill: false,
            barThickness: 10,
          },
          {
            label: "Level 4",
            backgroundColor: "#c62828",
            borderColor: "#ed64a6",
            data:props.data.yaxis.level4,
            fill: false,
            barThickness: 10,
          },
          {
            label: "Level 5",
            backgroundColor: "#263238",
            borderColor: "#ed64a6",
            data: props.data.yaxis.level5,
            fill: false,
            barThickness: 10,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: false,
          text: "Orders Chart",
        },
        tooltips: {
          mode: "index",
          intersect: false,
        },
        hover: {
          mode: "nearest",
          intersect: true,
        },
        legend: {
          labels: {
            fontColor: "rgba(0,0,0,.4)",
          },
          align: "end",
          position: "bottom",
        },
        scales: {
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "Data Range",
              },
              gridLines: {
                borderDash: [2],
                borderDashOffset: [2],
                color: "rgba(33, 37, 41, 0.3)",
                zeroLineColor: "rgba(33, 37, 41, 0.3)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          ],
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: false,
                labelString: "Value",
              },
              gridLines: {
                borderDash: [2],
                drawBorder: false,
                borderDashOffset: [2],
                color: "rgba(33, 37, 41, 0.2)",
                zeroLineColor: "rgba(33, 37, 41, 0.15)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          ],
        },
      },
    };
    let ctx = document.getElementById("bar-chart2").getContext("2d");
    window.myBar = new Chart(ctx, config);
  }, []);
  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full max-w-full flex-grow flex-1">
              <h6 className="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
                Distribution
              </h6>
              <h2 className="text-blueGray-700 text-xl font-semibold">
              GPA
              </h2>
            </div>
          </div>
        </div>
        <div className="p-4 flex-auto">
          {/* Chart */}
          <div className="relative h-350-px">
            <canvas id="bar-chart2"></canvas>
          </div>
        </div>
      </div>
    </>
  );
}
